import { render, staticRenderFns } from "./AlphaTable.vue?vue&type=template&id=6e45c311"
import script from "./AlphaTable.vue?vue&type=script&lang=js"
export * from "./AlphaTable.vue?vue&type=script&lang=js"
import style0 from "./AlphaTable.vue?vue&type=style&index=0&id=6e45c311&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports